import { render, staticRenderFns } from "./fdInventory9.vue?vue&type=template&id=8b5174de"
import script from "./fdInventory9.vue?vue&type=script&lang=js"
export * from "./fdInventory9.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports